<template>
    <div class="upload_cls">
        <el-upload
                v-show="uploadflag"
                class="upload-demo"
                action=""
                :before-upload="beforeUpload"
                multiple
                :limit="limit"
                :accept="accept"
                :on-exceed="handleExceed" >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip" style="color: #ff2424">{{tips}}</div>
        </el-upload>
        <ul class="el-upload-list el-upload-list--text">
            <li v-for="o,i in this.fileList" :tabindex="i" :key="o.id" class="el-upload-list__item is-success">
                <a v-if="!tpFlag" class="el-upload-list__item-name" v-down="o.id"><i
                        class="el-icon-document"></i>{{o.name}}
                </a>
                <span v-if="tpFlag" class="el-upload-list__item-name" @click="tpylclick(o)"><i
                        class="el-icon-document"></i>{{o.name}}
                </span>
                <label class="el-upload-list__item-status-label" v-if="showTime">
                    {{o.cdate}}
                 </label>
                <i @click="delfile(o)" v-show="delflag" class="el-icon-close"></i>
            </li>
        </ul>
    </div>

</template>
<script>
    import uploaddown from '../../utils/updownfile'
    import _ from 'loadsh'
    import ss from "../../api/SystemService";
    export default {
        props:{
            refid:null,
            reftype:null,
            limit:{
                type: Number,
                default: 0
            },
            tips:null,
            //是否可以上传
            uploadflag:{
                type: Boolean,
                default: false
            },
            //是否可以删除
            delflag:{
                type: Boolean,
                default: false
            },
            showtime:{
                type:Boolean,
                default:true,
            },
            //是否需要上传PDF格式
            pdfFlag:{
                type: Boolean,
                default: false
            },
            //是否需要上传图片格式
            isTp:{
                type: Boolean,
                default: false
            },
            //是否预览图片
            tpFlag:{
                type: Boolean,
                default: false
            },
          //是否需要上传图片格式或PDF控制文件大小在5M
            isTpAndPdf:{
              type: Boolean,
              default: false
            },
            isTpAndPdfNotSize:{
                type: Boolean,
                default: false
            },
            isTpAndPdfAndXml:{
                type: Boolean,
                default: false
            },
            accept:null
        },
        computed: {
            reftypeVal: function () {
                return this.reftype;
            },
            refidVal:function(){
                    return this.refid;
                },
            showTime:function () {
                return this.showtime;
            }
        },
        watch: {
            refid(val, newval) {
                this.fileList = [];
                this.loadFilelist(val)
            }
        },
        data() {
            return {
                fileList: []
            };
        },
        created() {
            this.loadFilelist(null);
        },
        methods: {
            tpylclick(file){
                this.$emit('tpclick', file.id);
                window.open('https://oms.haierbiomedical.com/' + file.saveurl, '_blank')
            },
            loadFilelist(refid){
                uploaddown.listdownfile({refid:refid||this.refidVal, reftype: this.reftypeVal}).then(rd => {
                    this.fileList = rd.obj;
                })
            },
            beforeUpload(file){
                if(this.limit!=0 && this.fileList.length>=this.limit){
                    this.$msg.msge("超过文件个数限制,请先删除后再操作!");
                    return false;
                }
                if (this.pdfFlag == true) {
                    var pdf = this.confirmEnding(file.name, ".pdf");
                    if (pdf == false) {
                        this.$msg.msge("请上传PDF格式的文件！");
                        return false;
                    }
                }

                if (this.isTp == true) {

                    const isFile = file.type === 'image/jpg'||file.type === 'image/jpeg' || file.type === 'image/png';

                    if (isFile == false) {
                        this.$msg.msge('上传文件的格式只能是 JPG或PNG 格式!');
                        return false;
                    }
                }
                //支持图片和pdf 控制在5M
              if (this.isTpAndPdf == true) {

                const isFile = file.type === 'image/jpg'||file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf';
                const isLt5M = file.size / 1024 / 1024 < 5;
                console.log(isFile,file.type)

                if (!isFile) {
                  this.$message.error('上传文件的格式只能是 JPG或PNG或PDF 格式!');
                  return false;
                }
                if (!isLt5M) {
                  this.$message.error('上传文件的大小不能超过 5M!');
                  return false;
                }
              }
                //支持图片和pdf 不限制大小
                if (this.isTpAndPdfNotSize == true) {
                    const isFile = file.type === 'image/jpg'||file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf';
                    console.log(isFile,file.type)

                    if (!isFile) {
                        this.$message.error('上传文件的格式只能是 JPG或PNG或PDF 格式!');
                        return false;
                    }
                }
                //支持图片和pdf和xml 控制在5M
                if (this.isTpAndPdfAndXml == true) {

                    const isFile = file.type === 'image/jpg'||file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf' || file.type === 'text/xml';
                    const isLt5M = file.size / 1024 / 1024 < 5;
                    console.log(isFile,file.type)

                    if (!isFile) {
                        this.$message.error('上传文件的格式只能是 JPG或PNG或PDF或xml 格式!');
                        return false;
                    }
                    if (!isLt5M) {
                        this.$message.error('上传文件的大小不能超过 5M!');
                        return false;
                    }
                }
                uploaddown.upload(file, {refid: this.refidVal, reftype: this.reftypeVal, flag: this.limit}).then(rd => {
                    this.fileList.unshift(rd.obj)
                    this.$emit('filecallback', this.fileList);
                }).catch(error=>{
                    return Promise.reject(error);
                })
              return false;
            },
            confirmEnding(str, target) {
                var start = str.length-target.length;
                var arr = str.substr(start,target.length);
                if(arr == target){
                    return true;
                }
                return false;
            },
            handleExceed(files, fileList) {
                this.$msg.msge("超过文件个数限制");
            },
            delfile(file) {
                if (this.delflag) {
                    this.$msg.confirm("附件删除不可逆，请谨慎操作，确认删除?",()=>{
                        uploaddown.deleteById(file.id).then(rd => {
                            this.fileList = _.reject(this.fileList,{id:file.id})
                            this.$emit('filecallback', this.fileList,file.refid);
                        })
                    })
                    return true;
                }
                this.$msg.msge("禁止删除附件！")
                return false;
            }
        },

    }
</script>
<style>
    .upload_cls .el-upload-list__item:first-child {
        margin-top: 0px;
    }
    .el-icon-close{
        display: block;
    }
    .el-upload-list__item.is-success .el-upload-list__item-status-label {
         width: auto!important;
         margin-top: 0px!important;
        right: 25px!important;
    }
    .el-upload-list__item .el-icon-close {
        display: block;
    }
    .el-upload-list__item.is-success:active .el-icon-close-tip, .el-upload-list__item.is-success:focus .el-upload-list__item-status-label, .el-upload-list__item.is-success:hover .el-upload-list__item-status-label, .el-upload-list__item.is-success:not(.focusing):focus .el-icon-close-tip {
        display: block!important;
    }
</style>
